<div class="relative group flex-grow h-full overflow-hidden">
  <mat-card class="h-full w-full overflow-auto">
    @if (timelineItem && !timelineItem.corrupted) {
      @if (timelineItem.type === taDirectTypeEnum.MESSAGE) {
        <phoenix-timeline-message-detail
          [selectedId]="timelineItem.id"
        ></phoenix-timeline-message-detail>
      } @else if (timelineItem.type === taDirectTypeEnum.CONVERSATION) {
        <phoenix-timeline-messages-detail
          class="flex flex-col h-full"
          [selectedConversation]="timelineItem"
        ></phoenix-timeline-messages-detail>
      } @else {
        <phoenix-timeline-detail
          [timelineSelectedItem]="timelineItem"
          [movementDisabled]="movementDisabled"
          [removeMovement]="removeMovement"
          (imgMovement)="onImgMovement($event)"
        ></phoenix-timeline-detail>
      }
    } @else if (timelineItem?.corrupted) {
      <div class="text-center text-red-500">
        This data is corrupted and cannot be displayed.
      </div>
    }
  </mat-card>
  @if (!removeMovement && timelineItem) {
    <button
      (click)="onImgMovement('previous'); $event.stopPropagation()"
      mat-mini-fab
      color="primary"
      class="material-icons round-btn !absolute !top-1/2 !-translate-y-1/2 !left-4 !opacity-0 transition-opacity !duration-300 !ease-out group-hover:!opacity-100 z-20"
      aria-label="Previous timeline"
      [disabled]="
        movementDisabled === 'previous' || movementDisabled === 'both'
      "
    >
      arrow_back
    </button>

    <button
      (click)="onImgMovement('next'); $event.stopPropagation()"
      mat-mini-fab
      color="primary"
      class="material-icons round-btn !absolute !top-1/2 !-translate-y-1/2 !right-4 !opacity-0 transition-opacity !duration-300 !ease-out group-hover:!opacity-100 z-20"
      aria-label="Next timeline"
      [disabled]="movementDisabled === 'next' || movementDisabled === 'both'"
    >
      arrow_forward
    </button>
  }
</div>
